"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysValue = exports.nameOfMonths = void 0;
exports.nameOfMonths = [
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
];
exports.daysValue = [
    '۱',
    '۲',
    '۳',
    '۴',
    '۵',
    '۶',
    '۷',
    '۸',
    '۹',
    '۱۰',
    '۱۱',
    '۱۲',
    '۱۳',
    '۱۴',
    '۱۵',
    '۱۶',
    '۱۷',
    '۱۸',
    '۱۹',
    '۲۰',
    '۲۱',
    '۲۲',
    '۲۳',
    '۲۴',
    '۲۵',
    '۲۶',
    '۲۷',
    '۲۸',
    '۲۹',
    '۳۰',
    '۳۱',
];
